import axios from 'axios';

const API_URL = 'http://localhost:5000/api/student-requests';

// Yeni öğrenci kayıt talebi oluştur
export const submitStudentRequest = async (formData) => {
  const response = await axios.post(API_URL, formData);
  return response.data;
};
